import React from 'react';
import Background from '../../components/Background/Background';
import Header from '../../components/Header/Header';
import { FaChevronRight } from 'react-icons/fa';
import Button from '../../components/Button/Button';
import './_styles.choose.css';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { planeVariants } from '../../animations/plane';

const hotelVariants = {
  hidden: {
    translateY: 100,
    opacity: 0,
  },
  enter: {
    translateY: 0,
    opacity: 0.8,
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
      delay: 1,
    },
  },
  exit: {
    translateY: 100,
    opacity: 0,
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
      delay: 0.5,
    },
  },
};

const Choose = () => {
  const navigate = useNavigate();

  const onFlightsClick = () => {
    navigate('/flights');
  };

  const onHotelsClick = () => {
    navigate('/hotels');
  };

  return (
    <Background image='choose-page'>
      <Header title='Choose flights or hotels' />
      <div className='choose-content'>
        <Button type='secondary' onClick={onFlightsClick}>
          <p className='flex-1'>Flights</p> <FaChevronRight />
        </Button>
        <Button type='secondary' onClick={onHotelsClick} delay={0.15}>
          <p className='flex-1'>Hotels</p> <FaChevronRight />
        </Button>
      </div>
      <motion.img
        initial='hidden'
        animate='enter'
        exit='exit'
        src='/plane.png'
        className='plane'
        variants={planeVariants}
      />
      <motion.img
        src='/hotel.png'
        className='hotel'
        initial='hidden'
        animate='enter'
        exit='exit'
        variants={hotelVariants}
      />
    </Background>
  );
};

export default Choose;
